










import { Component, Prop, Vue } from 'vue-property-decorator';
import { networkSvc } from '@/services';
import { NetworkTemplate, NetworkAccountOption } from '@/types';
import NetworkTemplateForm from './NetworkTemplateForm.vue';

@Component({
  name: 'network-account-options',
  components: {
    NetworkTemplateForm
  }
})
export default class NetworkAccountOptions extends Vue {
  @Prop()
  private networkAccountOption!: NetworkAccountOption;

  get filterOptions() {
    return this.networkAccountOption.options!.filter(
      option => option.description
    );
  }
}
